import React, { useEffect, useState } from "react";
import ReactLoading from 'react-loading';
//
export default function LoadChart({ children, data, trigger, onChange }) {
    //
    //TIMER TO SHOW NOT FOUND DATA MESSAGE
    const [loadTimeEnd, setLoadTimeEnd] = useState(false);
    useEffect(() => {
        if (loadTimeEnd === true) {
            onChange();
        } else {
            setTimeout(() => {
                setLoadTimeEnd(true);
                onChange();
            }, 5000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, trigger]);
    //
    return (
        <>
            {
                loadTimeEnd ?
                    <>
                        {children}
                    </>
                    :
                    <ReactLoading type='spin' color='#38ABAF' className="m-auto mt-4" />
            }
        </>
    );
}
